import { useTheme } from "../context/ThemeContext";
import { useAuth }  from "../context/AuthContext";
import { useCart }  from "../context/CartContext";

export default function Navbar({ activePage, setActivePage, openAuthModal }) {
  const { theme, toggleTheme } = useTheme();
  const { currentUser, clearToken, isLoggedIn } = useAuth();
  const { cartCount, setCartOpen } = useCart();

  const navLinks = [
    { id: "home",        label: "Home" },
    { id: "restaurants", label: "Restaurants" },
    { id: "menu",        label: "Menu" },
    { id: "orders",      label: "My Orders" },
  ];

  const handleLogout = () => {
    clearToken();
    setActivePage("home");
  };

  return (
    <nav
      style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 200,
        height: "68px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0 clamp(1rem,5vw,3rem)",
        background: theme === "dark" ? "rgba(17,16,9,0.88)" : "rgba(249,245,240,0.88)",
        backdropFilter: "blur(20px)",
        borderBottom: "1px solid var(--border)",
        transition: "background .3s, border-color .3s",
      }}
    >
      {/* Logo */}
      <div
        onClick={() => setActivePage("home")}
        style={{
          fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: "1.6rem",
          color: "var(--text)", cursor: "pointer", letterSpacing: "-0.04em",
          display: "flex", alignItems: "center", gap: "0.4rem",
        }}
      >
        🍽 Sa<span style={{ color: "var(--primary)" }}>v</span>ora
      </div>

      {/* Nav Links */}
      <ul style={{ display: "flex", gap: "0.2rem", listStyle: "none" }}>
        {navLinks.map(link => (
          <li key={link.id}>
            <a
              onClick={() => setActivePage(link.id)}
              style={{
                fontSize: "0.875rem", fontWeight: 500,
                color: activePage === link.id ? "var(--primary)" : "var(--text2)",
                background: activePage === link.id ? "var(--primary-l)" : "transparent",
                textDecoration: "none", padding: "0.45rem 0.9rem",
                borderRadius: "99px", cursor: "pointer",
                transition: "all .2s", display: "block",
              }}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>

      {/* Right side */}
      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          style={{
            display: "flex", alignItems: "center", gap: ".35rem",
            background: "var(--surface2)", border: "1.5px solid var(--border)",
            borderRadius: "99px", padding: ".3rem .6rem", cursor: "pointer",
            fontSize: ".78rem", fontWeight: 500, color: "var(--text2)",
            transition: "all .2s",
          }}
        >
          {theme === "dark" ? "🌙 Dark" : "☀️ Light"}
        </button>

        {/* Cart button */}
        <button
          onClick={() => setCartOpen(true)}
          style={{
            width: "40px", height: "40px", borderRadius: "12px",
            border: "1.5px solid var(--border)", background: "var(--surface)",
            color: "var(--text)", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "1.05rem", transition: "all .2s", position: "relative",
          }}
        >
          🛒
          {cartCount > 0 && (
            <span style={{
              position: "absolute", top: "-5px", right: "-5px",
              background: "var(--primary)", color: "#fff",
              fontSize: "0.65rem", fontWeight: 700,
              width: "18px", height: "18px", borderRadius: "50%",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              {cartCount}
            </span>
          )}
        </button>

        {/* Auth */}
        {isLoggedIn() && currentUser ? (
          <button
            onClick={handleLogout}
            title={`Logout: ${currentUser.email}`}
            style={{
              width: "36px", height: "36px", borderRadius: "10px",
              border: "2px solid var(--primary)", background: "var(--primary-l)",
              color: "var(--primary)", fontWeight: 700, fontSize: "0.85rem",
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >
            {currentUser.email?.charAt(0).toUpperCase()}
          </button>
        ) : (
          <button
            onClick={() => openAuthModal("login")}
            style={{
              background: "var(--primary)", color: "#fff", border: "none",
              padding: "0.5rem 1.25rem", borderRadius: "99px",
              fontWeight: 600, fontSize: "0.875rem", cursor: "pointer",
              transition: "all .2s",
            }}
          >
            Log In
          </button>
        )}
      </div>
    </nav>
  );
}